import Info from "@assets/icons/info.svg";
import Skeleton from "react-loading-skeleton";

const CPGOrderFlowDetailsSkeleton = () => {
  return (
    <div className="flex flex-col gap-[12px] mt-[16px]">
      {/* Summary card */}
      <div className="flex flex-col py-[8px] px-[12px] space-y-[12px] border border-border-subtle bg-bg-base rounded-lg">
        <div className="flex flex-row justify-between">
          <Skeleton height={20} width={72} />
          <Skeleton height={20} width={88} />
        </div>
        <div className="flex flex-row justify-between items-center">
          <span className="text-text-base text-[10px] font-medium">
            Transaction Type
          </span>
          <Skeleton height={12} width={120} />
        </div>
        <div className="flex flex-row justify-between items-center">
          <span className="text-text-base text-[10px] font-medium">Source</span>
          <Skeleton height={12} width={80} />
        </div>
        <div className="flex flex-row justify-between items-center">
          <span className="text-text-base text-[10px] font-medium">
            Trx Date & Time
          </span>
          <Skeleton height={12} width={140} />
        </div>
        <div className="border-b border-border-subtle" />
        <div className="flex flex-row justify-between items-center">
          <span className="text-text-base text-[10px] font-medium">
            MID | UID
          </span>
          <Skeleton height={12} width={160} />
        </div>
      </div>

      {/* Payment details card */}
      <div className="flex flex-col py-[8px] px-[12px] space-y-[12px] border border-border-subtle bg-bg-base rounded-lg">
        <div className="flex flex-row items-center gap-[4px]">
          <div className="bg-bg-page-body rounded-full h-[24px] p-[2px] w-[24px] mr-[4px] flex items-center justify-center">
            <img src={Info} alt="Info" />
          </div>
          <span className="text-[14px] font-normal text-text-base">
            Payment Details
          </span>
        </div>

        <div className="flex flex-row justify-between items-center">
          <span className="text-text-base text-[10px] font-medium">
            Base Currency
          </span>
          <div className="flex flex-row gap-[4px] items-center">
            <Skeleton circle height={14} width={14} />
            <Skeleton height={12} width={48} />
          </div>
        </div>
        <div className="flex flex-row justify-between items-center">
          <span className="text-text-base text-[10px] font-medium">
            Settled Currency
          </span>
          <div className="flex flex-row gap-[4px] items-center">
            <Skeleton circle height={14} width={14} />
            <Skeleton height={12} width={48} />
          </div>
        </div>
        <div className="flex flex-row justify-between items-center">
          <span className="text-text-base text-[10px] font-medium">
            Network
          </span>
          <Skeleton height={12} width={56} />
        </div>
        <div className="flex flex-row justify-between items-center">
          <span className="text-text-base text-[10px] font-medium">
            Order ID
          </span>
          <Skeleton height={12} width={180} />
        </div>
        <div className="flex flex-col gap-[4px]">
          <span className="text-text-base text-[10px] font-medium">
            To address
          </span>
          <Skeleton height={12} width="100%" />
        </div>
        <div className="flex flex-col gap-[4px]">
          <span className="text-text-base text-[10px] font-medium">
            System Notes
          </span>
          <Skeleton height={12} count={2} />
        </div>
        <div className="flex flex-col gap-[4px]">
          <span className="text-text-base text-[10px] font-medium">
            User Notes
          </span>
          <Skeleton height={12} width="85%" />
        </div>
        <div className="border-b border-border-subtle" />
        {[
          "Requested in Base",
          "Requested in Settled",
          "Received in base",
          "Received",
          "Commissions",
          "Credited",
        ].map((label) => (
          <div
            key={label}
            className="flex flex-row justify-between items-center"
          >
            <span className="text-text-base text-[10px] font-medium">
              {label}
            </span>
            <Skeleton height={12} width={100} />
          </div>
        ))}

        <div className="flex flex-row items-center justify-between gap-2 pt-[4px]">
          <Skeleton height={36} className="flex-1" />
          <Skeleton height={36} className="flex-1" />
        </div>
        <div className="flex flex-row items-center justify-between gap-2">
          <Skeleton height={36} className="flex-1" />
          <Skeleton height={36} className="flex-1" />
        </div>
      </div>

      {/* Transaction details card */}
      <div className="flex flex-col py-[8px] px-[12px] space-y-[12px] border border-border-subtle bg-bg-base rounded-lg">
        <div className="rounded-lg flex flex-col my-2">
          <div className="flex flex-col rounded-lg p-[8px] bg-bg-trx-card-header rounded-t-lg rounded-b-none">
            <span className="text-[12px] font-semibold text-center">
              Transaction Details
            </span>
          </div>
          <div className="flex flex-col bg-[#FFFFFF] p-[8px] rounded-t-none rounded-b-lg gap-[8px]">
            <div className="flex flex-row justify-between mb-1">
              <span className="font-medium text-[12px] text-text-label">
                From address
              </span>
              <Skeleton height={20} width={24} />
            </div>
            <Skeleton height={12} width="100%" />
            <div className="flex flex-row justify-between mt-2">
              <span className="font-medium text-[12px] text-text-label">
                To address
              </span>
              <Skeleton height={20} width={24} />
            </div>
            <Skeleton height={12} width="100%" />
            <div className="flex flex-row justify-between w-full mt-[12px]">
              <span className="font-medium text-[12px] text-text-label">
                Transaction Hash
              </span>
              <div className="flex flex-row gap-[8px]">
                <Skeleton height={20} width={24} />
                <Skeleton height={20} width={24} />
              </div>
            </div>
            <Skeleton height={12} width="100%" />
            <div className="p-[8px] mt-[12px] flex flex-row justify-between w-full border-t border-t-border-subtle">
              <div className="flex flex-col items-center gap-[4px]">
                <span className="font-medium text-[12px] text-text-label">
                  Amount
                </span>
                <Skeleton height={14} width={72} />
              </div>
              <div className="w-px bg-border-subtle" />
              <div className="flex flex-col items-center gap-[4px]">
                <span className="font-medium text-[12px] text-text-label">
                  Confirmations
                </span>
                <Skeleton height={14} width={48} />
              </div>
              <div className="w-px bg-border-subtle" />
              <div className="flex flex-col items-end gap-[4px]">
                <span className="font-medium text-[12px] text-text-label">
                  Status
                </span>
                <Skeleton height={14} width={64} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CPGOrderFlowDetailsSkeleton;
